import { render } from "./ClusterRegisterForm.vue?vue&type=template&id=1fa2c886"
import script from "./ClusterRegisterForm.vue?vue&type=script&lang=js"
export * from "./ClusterRegisterForm.vue?vue&type=script&lang=js"
script.render = render

export default script